import { render, staticRenderFns } from "./talent_acquisition_detial.vue?vue&type=template&id=1b594f98&scoped=true"
import script from "./talent_acquisition_detial.vue?vue&type=script&lang=js"
export * from "./talent_acquisition_detial.vue?vue&type=script&lang=js"
import style0 from "./talent_acquisition_detial.vue?vue&type=style&index=0&id=1b594f98&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b594f98",
  null
  
)

export default component.exports